export enum EntityType {
  teams = "teams",
  members = "members",
}

export interface RolesAndPermissions {
  level: PermissionLevel;
  [EntityType.teams]: PermissionGrant[];
  [EntityType.members]: PermissionGrant[];
  owners: string[];
}

export enum PermissionLevel {
  all_members = "all_members",
  teams = "teams",
  advanced = "advanced",
  editors = "editors",
  contributors = "contributors",
  nobody = "nobody",
}

interface PermissionGrant {
  access: PermissionAccess;
  entity: string;
}

declare enum PermissionAccess {
  owner = "owner",
  full_access = "full_access",
  editor = "editor",
  contributor = "contributor",
  commenter = "commenter",
  viewer = "viewer",
  assignee = "assignee",
  guest = "guest",
  readonly = "read_only",
  none = "none",
}
